<template>
  <div class="tab-content">
    <SectionTitle
      class="mt-3"
      :has-line="true"
      :title="'Alternativa de ubicación recomendada y su justificación'"
    />
    <div class="row">
      <div class="col-12 col-md-3">
        <label class="input-label">Grado:</label>
        <ValidationProvider v-slot="{ errors }" rules="required" mode="eager">
          <CustomDropDown
            v-model="model.grade"
            placeholder="Seleccione"
            fieldkey="id"
            fieldname="edenGradeDescSpanish"
            :disabled="isReadOnly"
            :error="errors[0]"
            custom-error-msg="Favor seleccione grado."
            :options="gradeOptions"
            @input="filterAges"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-3">
        <label class="input-label">Rango de Edad:</label>
        <ValidationProvider v-slot="{ errors }" rules="required" mode="eager">
          <CustomDropDown
            v-model="model.ageRange"
            placeholder="Seleccione"
            fieldkey="id"
            fieldname="text"
            :error="errors[0]"
            custom-error-msg="Favor seleccione edad."
            :disabled="true"
            :options="ageRange"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-6">
        <label class="input-label">Alternativa:</label>
        <ValidationProvider v-slot="{ errors }" rules="required" mode="eager">
          <CustomDropDown
            v-model="model.alternative"
            placeholder="Seleccione"
            fieldkey="id"
            fieldname="spashortDescription"
            :disabled="isReadOnly"
            :error="errors[0]"
            custom-error-msg="Favor seleccione alternativa."
            :options="alternativeSelection"
            @input="clearFocusType"
          />
        </ValidationProvider>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <div class="dropdown-divider mt-0 pb-2 w-100" />
      </div>
    </div>
    <div v-if="canShowFocusType" class="row">
      <div class="col-12 col-md-3">
        <label class="input-label">Tipo de Enfoque:</label>
        <ValidationProvider v-slot="{ errors }" rules="required" mode="eager">
          <CustomDropDown
            v-model="model.focusType"
            placeholder="Seleccione"
            fieldkey="id"
            fieldname="name"
            :disabled="isReadOnly"
            :error="errors[0]"
            custom-error-msg="Favor seleccione tipo de enfoque."
            :options="focusTypeOptions"
          />
        </ValidationProvider>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-3">
        <label class="input-label">
          Justificación para la recomendación de la alternativa de ubicación:
        </label>
        <ValidationProvider v-slot="{ errors }" rules="required" mode="eager">
          <custom-text-area
            v-model="model.justification"
            class="w-100"
            :disabled="isReadOnly"
            :error="errors[0]"
            custom-error-msg="Favor escriba la justificación."
            :rows="5"
            :maxlength="3000"
          />
        </ValidationProvider>
      </div>

      <div class="col-12 mt-5">
        <label class="input-label">
          Descripción de la alternativa de ubicación solicitada:
        </label>
        <ValidationProvider v-slot="{ errors }" rules="required" mode="eager">
          <custom-text-area
            v-model="model.description"
            class="w-100"
            :disabled="isReadOnly"
            :error="errors[0]"
            custom-error-msg="Favor escriba descripción de la alternativa de ubicación solicitada."
            :rows="5"
            :maxlength="3000"
          />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import SectionTitle from 'SectionTitle';
import CustomDropDown from '@/components/common/CustomDropDown.vue';
import CustomTextArea from '@/components/common/CustomTextArea';
import {
  getTapRequestSchoolGrade,
  getTapRequestFocusType,
} from '@/services/api/tapRequest.api.js';
import { gradesEnum } from '@/components/pei/ubication-tech-assistance/_types';

export default {
  name: 'UbicationAlternative',
  components: {
    SectionTitle,
    CustomDropDown,
    CustomTextArea,
    ValidationProvider,
  },
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ageRange: [
        {
          id: 1,
          text: '3-4 años',
          codeType: 'PeiAlternatePlacementPrescholar',
        },
        {
          id: 2,
          text: '5-21 años',
          codeType: 'PeiAlternatePlacement',
        },
      ],
      altUbicationOptions: [],
      alternativeSelection: [],
      gradeOptions: [],
      focusTypeOptions: [],
      selectedRange: null,
    };
  },
  watch: {
    'model.ageRange': {
      immediate: false,
      deep: false,
      handler(val) {
        if (this.model.alternative?.codeNo) {
          this.model.alternative = null;
        }
        this.alternativeSelection = this.altUbicationOptions.filter((item) => {
          return item.codeType === val.codeType;
        });
      },
    },
  },
  computed: {
    canShowFocusType() {
      return (
        this.model.alternative?.id === 2000 ||
        this.model.alternative?.id === 107
      );
    },
  },

  async created() {
    await Promise.all([
      this.loadAlternativeUbications(),
      this.loadGrade(),
      this.loadFocusType(),
    ]);
    if (this.model.grade) {
      this.filterAges();
    }
  },
  async mounted() {},
  methods: {
    async loadAlternativeUbications() {
      const codeType = [1, 3];

      const { data } = await this.$ApiGet('api/pei/getalternatelocations', {
        codeType,
        forJustification: true,
      });

      if (data) {
        this.altUbicationOptions = data;
        if (this.model.ageRange) {
          this.alternativeSelection = this.altUbicationOptions.filter(
            (item) => {
              return item.codeType === this.model.ageRange.codeType;
            }
          );
        }
      }
      if (this.model.alternative) {
        const selectedCodeType = this.altUbicationOptions.filter((item) => {
          return item.id === this.model.alternative.id;
        })[0].codeType;

        const altAgeRange = this.ageRange.filter((a) => {
          return a.codeType == selectedCodeType;
        });
        this.model.ageRange = altAgeRange.length > 0 ? altAgeRange[0] : null;

        this.alternativeSelection = this.altUbicationOptions.filter((item) => {
          return item.codeType === selectedCodeType;
        });
      }
    },
    filterAges() {
      if (this.model.grade.id == gradesEnum.Prekindergarten) {
        this.model.ageRange = this.ageRange[0];
      } else {
        this.model.ageRange = this.ageRange[1];
      }
    },
    async loadGrade() {
      const { data } = await getTapRequestSchoolGrade();
      if (data) {
        this.gradeOptions = data;
        const grade = this.gradeOptions.filter(
          (a) => a.id == this.model.gradeId
        );
        this.model.grade = grade.length > 0 ? grade[0] : null;
      }
    },
    async loadFocusType() {
      const { data } = await getTapRequestFocusType();
      if (data) {
        this.focusTypeOptions = data;

        const fType = this.focusTypeOptions.filter(
          (a) => a.id == this.model?.focusType?.id
        );
        this.model.focusType = fType.length > 0 ? fType[0] : null;
      }
    },
    clearFocusType() {
      this.model.focusType = null;
    },
  },
};
</script>

<style>
.input-label {
  color: #727272;
  font-size: 15px;
  font-weight: lighter;
}
</style>
